export const validateEmail = (value) => {
  const email = (value || '').trim();

  if (!email) {
    return 'Email is required.';
  }

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    return 'Please enter a valid email address.';
  }

  return '';
};
